import { Endereco } from "../../../models/Endereco";

const actions = {
  getEmpresa({ commit }) {
    commit("GET_EMPRESA");
  },

  setEmpresa({ commit }, empresa) {
    if (
      empresa.empresa &&
      empresa.empresa.endereco &&
      !Object.values(empresa.empresa.endereco).length
    ) {
      empresa.empresa.endereco = new Endereco();
    }
    commit("SET_EMPRESA", empresa);
  },
};

export default actions;
